module.exports = __webpack_public_path__ + "img/about.aaec2e44.png";